import MuiList, { type ListProps } from "@mui/material/List";
import MuiListItem from "@mui/material/ListItem";


List.Item = MuiListItem;

export default function List(props: ListProps) {
	return <MuiList {...props}/>;
}